import { render, staticRenderFns } from "./MuletpleChoice.vue?vue&type=template&id=0c3db896&scoped=true"
import script from "./MuletpleChoice.vue?vue&type=script&lang=js"
export * from "./MuletpleChoice.vue?vue&type=script&lang=js"
import style0 from "./MuletpleChoice.vue?vue&type=style&index=0&id=0c3db896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3db896",
  null
  
)

export default component.exports